<template>
  <div class="contain page2-con" id="Mobile2">
    <div class="top">
      <div class="titleBox">
        <span class="leftLine hidden-md-and-up"><i></i><i></i><i></i></span>
        <h3 :class="isShowAnimate ? 'red animated fadeInLeft' : 'none'">
          {{ title }}
        </h3>
        <span class="rightLine hidden-md-and-up"><i></i><i></i><i></i></span>
      </div>
      <p class="tips">点击下面按钮直接跳转</p>
      <ul class="btn-group">
        <!-- <router-link tag="li" to="http://www.athletics.org.cn/" class="red">
          中国田径协会官网
        </router-link>
        <router-link tag="li" to="http://ztrz.chinaath.com/login" class="red">
          认证服务管理系统
        </router-link> -->
        <li class="red" @click="jumpHandle(1)">中国田径协会官网</li>
        <li class="red" @click="jumpHandle(2)">认证服务管理系统</li>
      </ul>
      <div class="codeBox hidden-md-and-up">
        <div class="code"> 
          <img src="@/assets/image/qrcode/offical.jpg" alt="" />
          
        </div><p>扫描关注官方公众号</p>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="left-top">
          <ul class="first-ul hidden-sm-and-down">
            <li
              class="first-li"
              v-for="(item, index) in firstPlateData"
              :key="index"
              @click="gotoService(item.id)"
            >
              <!-- <router-link
                tag="span"
                :to="`/service/certification?id=${item.id}`"
                > -->
              <h3>{{ item.name }}</h3>
              <p>{{ item.desc }}</p>
              <!-- <router-link
                tag="span"
                :to="`/service/certification?id=${item.id}`"
                >查看详情 ></router-link
              > -->
              <!-- </router-link> -->
            </li>
            <!-- <br /> -->
            <li
              class="second-li"
              v-for="(item, index) in secondPlateData"
              :key="index + 4"
              @click="gotoService(item.id)"
            >
              <!-- <router-link
                tag="span"
                :to="`/service/certification?id=${item.id}`"
                > -->
              <h3>{{ item.name }}</h3>
              <p>{{ item.desc }}</p>
              <!-- <router-link
                tag="span"
                :to="`/service/certification?id=${item.id}`"
                >查看详情 ></router-link
              ></router-link
              > -->
            </li>
          </ul>
          <!-- 移动端展示 -->
          <ul class="m-ul hidden-md-and-up">
            <li v-for="(item, index) in plateData" :key="index">
              <div class="title">
                <h3>{{ item.name }}</h3>
                <router-link
                  tag="span"
                  :to="`/service/certification?id=${item.id}`"
                >
                  <img src="@/assets/image/home/mobile/more.png" alt="more" />
                </router-link>
              </div>
              <p>{{ item.desc }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="right-title">
          <div class="line hidden-sm-and-down"></div>
          <h2 :class="isShowAnimate ? 'animated fadeInRight' : 'none'">
            业务简介
          </h2>
          <h6>ABOUT US</h6>
        </div>
        <div class="right-con">
          <p v-html="businessProfile">
           
          </p>
        </div>
      </div>
    </div>
    <!-- </el-container> -->
  </div>
</template>

<script>
import biz from "@/api/biz.js";
import {  info } from "../../../api/aboutUs";
export default {
  data() {
    return {
      screenWeight: 0, // 屏幕宽度
      screenHeight: 0,
      title: "认证服务管理系统",
      plateData: [
        {
          id: 0,
          name: "场地验收",
          desc: "",
        },
        {
          id: 1,
          name: "面层审定",
          desc: "",
        },
        {
          id: 4,
          name: "步道审定",
          desc: "",
        },
        {
          id: 3,
          name: "器材审定",
          desc: "",
        },
        {
          id: 2,
          name: "芯片审定",
          desc: "",
        },
        {
          id: 5,
          name: "培训&注册",
          desc: "",
        },
        {
          id: 6,
          name: "咨询服务",
          desc: "",
        },
      ],
      isShowAnimate: false,
      businessProfile: '',
        // "认证服务中心以中国田径协会现有认证业务为核心，重点梳理田径认证及相关业务标准化、体系化、系统化，实现认证服务数字化、一体化。致力成为集认证、培训、科研、政策研究、标准制定、国际合作、咨询服务于一体的综合性技术服务机构。我们的认证服务范围为：在全国范围内开展田径场地验收审定；场地（跑道）合成面层产品审定；田径器材、竞赛设施及运动装备审定；计时芯片传感系统审定；场地划线师培训注册管理；场地验收专家培训注册管理；芯片验收专家培训注册管理以及其他相关的一系列业务。",
    };
  },
  computed: {
    firstPlateData: function () {
      return this.plateData.filter((item, index) => index < 4);
    },
    secondPlateData: function () {
      return this.plateData.filter((item, index) => index > 3);
    },
  },
  methods: {
    setAnimate() {
      this.isShowAnimate = true;
    },
    gotoService(id){
      this.$router.push({
        path: `/service/certification?id=${id}`,
      });
    },
    getServices() {
      let self = this;
      biz.list().then((res) => {
        if (res.errCode == 0) {
          res.data.list.forEach((b) => {
            var p = self.plateData.filter((x) => x.name == b.name)[0];
            if (p) {
              p.desc = b.desc;
            }
          });
        }
      });
    },
    jumpHandle(type) {
      let url = "http://www.athletics.org.cn/";
      if (type == 2) {
        url = "http://ztrz.chinaath.com/login";
      }
      window.open(url);
    },
  },
  mounted() {
    this.getServices();
    info(["companyInfo"]).then(
        (res) => {
          if (res.errCode == 0) {
            this.businessProfile = res.data.companyInfo;          
          } else {
          }
        }
      );
    // this.screenWeight = document.documentElement.clientWidth;
    // this.screenHeight = document.documentElement.clientHeight;
  },
};
</script>

<style lang="scss" scoped>
.page2-con {
  width: 100%;
  height: 858px;
  background: url("~@/assets/image/home/screen2.png");
  background-size: cover;
  .red {
    color: #f73f2d;
  }
  .none {
    display: none;
  }
  .top {
    padding-top: 9%;
    padding-left: 9%;
    height: 60%;
    text-align: left;
    box-sizing: border-box;
    h3 {
      font-size: 38px;
    }
    p {
      margin-top: 15px;
      margin-bottom: 15px;
      font-size: 14px;
    }
    ul > li {
      display: inline-block;
      width: 200px;
      height: 40px;
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 20px;
      background: #f73f2d;
      border: 1px solid #f73f2d;
      color: #fff;
    }
    ul > li:last-child {
      margin-left: 20px;
    }
    ul > li:hover {
      cursor: pointer;
      border: 1px solid #f73f2d;
      color: #f73f2d;
      background: transparent;
    }
  }
  .bottom {
    height: 40%;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left,
    .right {
      width: 48%;
      flex: 1;
    }
    .left {
      height: 100%;
      display: flex;
      flex-direction: row;
      ul {
        height: 100%;
        li {
          text-align: left;
          padding-left: 15px;
          padding-top: 15px;
          padding-right: 15px;
          box-sizing: border-box;
          &:nth-child(5) {
            background: #f64845;
          }
          &:nth-child(6) {
            background: #f43d3a;
          }
          &:nth-child(7) {
            background: #e43735;
          }
        }
      }
      .first-li,
      .second-li {
        height: 50%;
        vertical-align: top;
        h3 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        p {
          text-align: left;
          margin-bottom: 20px;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-all;
        }
        span {
          cursor: pointer;
        }
      }
      .first-li {
        width: 25%;
        display: inline-block;
        background: #f64845;
        position: relative;
      }
      .first-li:nth-child(2) {
        background: #f43d3a;
      }
      .first-li:nth-child(3) {
        background: #e43735;
      }
      .first-li:nth-child(4) {
        background: #d43230;
      }
      // .first-li:hover, .second-li:hover{
      //   background-color: #bc190f;
      // }
      .first-li:hover::after, .second-li:hover::after{
        content: '';
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(164, 1, 0, .7);
        cursor: pointer;
      }
      .first-li:hover::before, .second-li:hover::before{
        content: '\e6e9';
        font-family: element-icons!important;
        text-align: center;
        position: absolute;
        border: 1px solid #fff;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: block;
        z-index: 10;
        line-height: 40px;
        top: calc(50% - 20px);
        left: calc(50% - 20px);
        font-size: 16px;
        cursor: pointer;
      }
      .second-li {
        width: 33.33%;
        display: inline-block;
        position: relative;
      }
    }
    .right {
      text-align: left;
      padding-left: 4%;
      padding-right: 4%;
      box-sizing: border-box;
      .right-title {
        margin-top: 10px;
        .line {
          width: 120px;
          height: 6px;
          border-radius: 3px;
          background: #f73f2d;
          margin-bottom: 15px;
        }
        h2 {
          font-size: 42px;
          line-height: 42px;
        }
        h6 {
          font-weight: normal;
          font-size: 18px;
        }
        h2,
        h6 {
          color: #f73f2d;
          margin-bottom: 15px;
        }
      }
      .right-con {
        font-size: 16px;
        p{
          text-align: justify;
        }
      }
    }
  }
}
//移动端
@media screen and (max-width: 960px) {
  #Mobile2 {
    background: none;
    height: 100% !important;
    .top {
      padding: 0.24rem 0 0.2rem 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .titleBox {
        display: flex;
        align-items: center;
        .leftLine,
        .rightLine {
          i {
            display: inline-block;
            width: 0.08rem;
            height: 0.08rem;
            border-radius: 50%;
            background: #cc3b3f;
            margin-right: 0.08rem;
          }
        }
        .leftLine {
          i:nth-child(1) {
            opacity: 0.37;
          }
          i:nth-child(2) {
            opacity: 0.59;
          }
          i:nth-child(3) {
            opacity: 0.85;
          }
        }
        .rightLine {
          i:nth-child(1) {
            opacity: 0.85;
            margin-left: 0.08rem;
          }
          i:nth-child(2) {
            opacity: 0.59;
          }
          i:nth-child(3) {
            opacity: 0.37;
          }
        }
        h3 {
          font-size: 0.2rem;
        }
      }
      .tips {
        font-size: 0.14rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.16rem;
        margin: 0.14rem 0 0.16rem 0;
      }
      .btn-group {
        display: flex;
        li {
          width: 1.36rem;
          height: 0.32rem;
          border-radius: 0.3rem;
          font-size: 0.14rem;
          line-height: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          background-color: #cc3b3f;
          border: 1px solid #cc3b3f;
        }
        li:hover {
          border: 1px solid #cc3b3f;
          color: #cc3b3f;
          background: transparent;
        }
      }
      .codeBox {
        width: 1.46rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 0.16rem;
        .code {
          width: 1rem;
          height: 1rem;
         
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          margin: 0.14rem 0 0 0;
          font-size: 0.14rem;
          color: #666666;
        }
      }
    }
    .bottom {
      background: #f6f6f6;
      height: 100%;
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      .right {
        width: 100%;
        padding: 0;
        .right-title {
          text-align: center;
          margin-top: 0.24rem;
          h2 {
            font-size: 0.2rem;
            line-height: 0.2rem;
            color: #333333;
            margin-bottom: 0.08rem;
          }
          h6 {
            font-size: 0.12rem;
            line-height: 0.12rem;
            color: #999999;
            margin-bottom: 0.24rem;
          }
        }
        .right-con {
          font-size: 0.14rem;
          line-height: 0.22rem;
          color: #333333;
          padding: 0 0.16rem;
        }
      }
      .left {
        width: 100%;
        margin-top: 0.16rem;
        margin-bottom: 0.12rem;
        .m-ul {
          padding: 0 0.16rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            padding: 0.12rem;
            background: #fff;
            width: 48%;
            height: 0.88rem;
            margin-bottom: 0.12rem;
            .title {
              display: flex;
              justify-content: space-between;
              margin-bottom: 0.08rem;
              h3 {
                font-size: 0.14rem;
                line-height: 0.2rem;
                color: #333333;
              }
              img {
                width: 0.06rem;
                height: 0.1rem;
              }
            }

            p {
              color: #666666;
              font-size: 0.12rem;
              line-height: 0.18rem;
              display: -webkit-box;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
</style>